import { TweenMax, TweenLite, CSSPlugin } from 'gsap';
import ScrollToPlugin from '../../../node_modules/gsap/src/uncompressed/plugins/ScrollToPlugin.js';

/*
 * Page class
 */
class Page{


  /**
   * Constructor
   */
  constructor(currentPageId){
    // Global
    this.initTemplate();
    // Page
    if (currentPageId == "home-page-container") {
      this.initHomePage();
    }
    // Throttle
    this.scrollTimer = 0;
    this.lastScrollFireTime = 0;
  }


  /**
   * Init template
   */
  initTemplate() {
  }


  /**
   * Init home page
   */
  initHomePage() {
  }


  /**
   * Ajax
   */
  ajax(url) {
    return new Promise(function(resolve, reject) {
      var xhr = new XMLHttpRequest();
      xhr.onload = function() {
        resolve(this.responseText);
      };
      xhr.onerror = reject;
      console.log(url);
      xhr.open('GET', url);
      xhr.send();
    });
  }


  /**
   * Throttled exec
   */
  throttledExec(fn){
    var minScrollTime = 400;
    var now = new Date().getTime();
    if (!this.scrollTimer) {
      if (now - this.lastScrollFireTime > (3 * minScrollTime)) {
        this.lastScrollFireTime = now;
      }
      this.scrollTimer = setTimeout(function() {
        this.scrollTimer = null;
        this.lastScrollFireTime = new Date().getTime();
        fn();
      }.bind(this), minScrollTime);
    }
  }


}

export default Page;
